import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboardIcon, CalculatorIcon, FileTextIcon, FolderIcon, AlertCircleIcon, SettingsIcon, LogOutIcon, XIcon } from 'lucide-react';
interface NavigationMenuProps {
  isOpen: boolean;
  onClose: () => void;
}
const NavigationMenu = ({
  isOpen,
  onClose
}: NavigationMenuProps) => {
  const location = useLocation();
  const menuItems = [{
    path: '/dashboard',
    label: 'Dashboard',
    icon: <LayoutDashboardIcon size={24} data-id="element-41" />
  }, {
    path: '/simulator',
    label: 'Simulador Financiero',
    icon: <CalculatorIcon size={24} data-id="element-42" />
  }, {
    path: '/agreements',
    label: 'Gestión de Acuerdos',
    icon: <FileTextIcon size={24} data-id="element-43" />
  }, {
    path: '/repository',
    label: 'Repositorio Documental',
    icon: <FolderIcon size={24} data-id="element-44" />
  }, {
    path: '/withdrawals',
    label: 'Desistimientos',
    icon: <AlertCircleIcon size={24} data-id="element-45" />
  }, {
    path: '/profile',
    label: 'Ajustes/Perfil',
    icon: <SettingsIcon size={24} data-id="element-46" />
  }];
  return <>
      {/* Overlay */}
      {isOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-20" onClick={onClose} data-id="element-47" />}
      {/* Sidebar */}
      <div className={`fixed top-0 left-0 h-full w-64 bg-white shadow-lg z-30 transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'}`} data-id="element-48">
        <div className="flex justify-between items-center p-4 border-b" data-id="element-49">
          <h2 className="text-xl font-semibold text-blue-600" data-id="element-50">SimFin</h2>
          <button onClick={onClose} className="p-2 rounded-lg hover:bg-gray-100" data-id="element-51">
            <XIcon size={24} data-id="element-52" />
          </button>
        </div>
        <nav className="p-4" data-id="element-53">
          <ul className="space-y-4" data-id="element-54">
            {menuItems.map(item => <li key={item.path} data-id="element-55">
                <Link to={item.path} className={`flex items-center p-3 rounded-lg min-h-[44px] ${location.pathname === item.path ? 'bg-blue-50 text-blue-600' : 'hover:bg-gray-100'}`} onClick={onClose} data-id="element-56">
                  <span className="mr-3 text-blue-600" data-id="element-57">{item.icon}</span>
                  <span data-id="element-58">{item.label}</span>
                </Link>
              </li>)}
            <li className="pt-4 border-t mt-4" data-id="element-59">
              <Link to="/" className="flex items-center p-3 rounded-lg min-h-[44px] text-red-600 hover:bg-red-50" data-id="element-60">
                <span className="mr-3" data-id="element-61">
                  <LogOutIcon size={24} data-id="element-62" />
                </span>
                <span data-id="element-63">Cerrar sesión</span>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </>;
};
export default NavigationMenu;